<div class="item-card" [class.selected]="selected">
  <div class="inner">
    <div class="fs-6 fw-bold pb-2">Balise : {{ baliseName }}</div>

    @for (pieces of groupPiece; track pieces.numeroSerie; let index = $index) {
      <div class="pb-1 d-inline-flex w-100" [class.color-red]="pieces.isAnomalie">
        @if (pieces.isAnomalie) {
          <mat-icon>warning</mat-icon>
        }
        <p class="mt-1 mb-0" style="margin-left: 1% !important">
          Numéro de série {{ index + 1 }} : {{ pieces.numeroSerie }}
        </p>
      </div>
    }

    @if (groupPiece.length === 0) {
      <div class="pb-1 text-secondary">Aucune pièces</div>
    }

    @if (selected) {
      @for (pieces of PieceNotSearch; track pieces.numeroSerie; let index = $index) {
        <div class="pb-1 text-secondary">
          Numéro de série {{ index + 1 }} : {{ pieces.numeroSerie }} {{ pieces.isAnomalie }}
        </div>
      }
    }
  </div>
</div>
